import { render, staticRenderFns } from "./ReportesPage.vue?vue&type=template&id=1769eb5a&scoped=true"
import script from "./ReportesPage.vue?vue&type=script&lang=ts"
export * from "./ReportesPage.vue?vue&type=script&lang=ts"
import style0 from "./ReportesPage.vue?vue&type=style&index=0&id=1769eb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1769eb5a",
  null
  
)

export default component.exports